<template>
  <div>
    <p class="task-detail-module-identifier my-3"><font-awesome-icon icon="fa-solid fa-cube" /> DAY {{ index + 1 }}</p>
    <div class="timeline-box">
      <div class="task-detail-card" v-for="(task, index) in dayTask.tasks" :key="index">
        <div class="row align-items-center justify-content-between">
          <div class="col-8">
            <div class="row">
              <div class="col">
                <p class="task-detail-title">{{ task.name }}</p>
                <!-- <p class="task-detail-subtitle">Created at: {{ formatDate(dayTask.createdDate) }}</p> -->
              </div>
            </div>
          </div>
          <!-- <div class="col-auto">
            <Button
              class="qb-btn qb-btn-outline-sm"
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + dayTask.id"
              ><font-awesome-icon icon="fa-solid fa-angle-down"
            /></Button>
          </div> -->
        </div>
      </div>

      <div class="collapse mb-2" :id="'collapse' + dayTask.id">
        <div class="p-2">
          <div class="card-box">
            <p class="task-timeline-title p-0 my-4" v-for="(data, index) in dayTask.tasks" :key="index">
              <font-awesome-icon icon="fa-solid fa-circle-check" />
              Task Description:
            </p>
          </div>
          <!-- <div class="row align-items-center my-1">
            <div class="col-12">
              <p class="task--title">Task Description:</p>
              <div class="task--description" v-html="dayTask.description"></div>

              <p class="task-detail-title">Task Type:</p>
              <Badge :label="dayTask.submissionType" class="badge-neon badge-neon-warning-outline" />
              <div class="d-flex gap-2 mt-3">
                <Button label="Edit" @onClick="edit()" class="qb-btn qb-btn-outline-sm" />
                <Button label="Delete" @onClick="deletemodal(dayTask)" class="qb-btn qb-btn-black-sm" />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Button from "../components/ButtonComponent.vue";
// import Badge from "../components/BadgeComponent.vue";

export default {
  name: "ContentListComponent",
  props: {
    index: {
      type: Number,
    },
    dayTask: {
      type: Object,
    },
    lastIndex: {
      type: Number,
    },
  },
  components: {
    // Button,
    // Badge,
  },
  computed: {
    // ...mapGetters({
    //   user: "getUser",
    // }),
  },
  methods: {
    showTaskPage(id) {
      this.$router.push({
        name: "ModuleDayDetailPage",
        params: { dayId: id },
      });
    },
    edit() {
      this.$emit("onEdit", this.dayTask);
    },
    deletemodal(dayTask) {
      this.$emit("showDelete", dayTask);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.card-box {
  background-color: $light-100;
  padding: 10px 15px;
  margin-left: 20px;
  border-radius: $field-border-radius;
}

.icon--arrow--right {
  cursor: pointer;
}

.task-detail-module-identifier {
  font-size: $font-size-sm;
  color: $light-600;
  font-weight: $font-weight-bold;
  margin: 0px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.task--title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;
}

.fa-circle-check {
  color: $dark-200;
  margin-right: 5px;
  background-color: $light-100;
}

.task--description {
  font-size: 14px;
}

.task-detail-card {
  background-color: $white;
  padding: 8px 12px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;
  margin-left: 20px;
  border: 1px solid $light-200;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

  &:hover {
    background-color: #fdfdfd;
  }
}

.timeline-box {
  border-left: 1px solid $dark-200;
  padding-left: 10px;
  margin-left: 10px;
}

.task-timeline-title {
  font-size: $font-size-md;
  margin: 0px;
  margin-left: -17px;
}

.task-detail-title {
  font-size: $font-size-md;
  font-weight: $font-weight-bold;
  color: $dark-400;
  margin-bottom: 0px;
}

.task-detail-subtitle {
  font-size: $font-size-sm;
  color: $light-600;
  font-weight: $font-weight-normal-1;
  margin-bottom: 0px;
}

.day--title {
  font-weight: 500;
  margin: 0px;
}

// .check--logo--completed {
//   filter: grayscale(0%);
//   opacity: 100%;
// }

// .check--logo--incompleted {
//   filter: grayscale(100%);
//   opacity: 30%;
// }

// .card--collapse--bottom {
//   border: 1px solid $light-100;
// }
</style>
